import React from "react";
import { Card, CardHeader, CardBody, Badge, Button, Row, Col } from "reactstrap";
import { Edit, Trash2, Clock, DollarSign, Users, Book } from "react-feather";
import { FILE_BASE_URL } from "../../../../../api-handle/apiService";

const ClassCard = ({ data, onEdit, onDelete }) => {
    return (
        <Row className="g-4">
            {data.map((classItem) => (
                <Col xl="4" lg="6" md="6" sm="12" key={classItem.id}>
                    <Card className="shadow-lg border-0 h-100">
                        <CardHeader className="d-flex justify-content-between align-items-center bg-dark text-white py-3 px-4">
                            <div className="d-flex align-items-center">
                                <Book size={20} className="me-2" />
                                <h5 className="mb-0 fw-bold">{classItem.className}</h5>
                            </div>
                            <Badge color={classItem.status === "Active" ? "success" : "danger"} style={{ color: "white" }} className="p-2">
                                {classItem.status}
                            </Badge>
                        </CardHeader>
                        <CardBody className="p-4 d-flex flex-column justify-content-between">
                            <div>
                                <img
                                    src={classItem.image ? `${FILE_BASE_URL}/${classItem.image}` : "https://picsum.photos/200/300"}
                                    alt="Class"
                                    className="img-fluid rounded mb-3"
                                    style={{ width: "100%", height: "150px", objectFit: "cover" }}
                                />
                                <p className="mb-3 d-flex align-items-center">
                                    <Clock size={20} className="me-2 text-primary" />
                                    <strong>Timing:</strong> {classItem.timing}
                                </p>
                                <p className="mb-3 d-flex align-items-center">
                                    <DollarSign size={20} className="me-2 text-success" />
                                    <strong>Price:</strong> ${classItem.price}
                                </p>
                            </div>
                            <div className="d-flex justify-content-between">
                                <Button color="primary" size="lg" className="d-flex align-items-center px-4 py-2" onClick={() => onEdit(classItem)}>
                                    <Edit size={22} className="me-2" /> Edit
                                </Button>
                                <Button color="danger" size="lg" className="d-flex align-items-center px-4 py-2" onClick={() => onDelete(classItem)}>
                                    <Trash2 size={22} className="me-2" /> Delete
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default ClassCard;
